import React, { Component } from 'react';
import ReactDataGrid from 'react-data-grid';
import DateTimePicker from 'react-widgets/lib/DateTimePicker';
import { Data } from 'react-data-grid-addons';
import { Grid, Row, Col, Panel, Button, Input, Breadcrumb, Tabs, Tab, ButtonToolbar } from 'react-bootstrap';
import { Bar } from 'react-chartjs-2';
import { Field } from 'redux-form';
import classNames from 'classnames';
import { Translate, I18n } from 'react-redux-i18n';
import moment from 'moment';

import ContentWrapper from '../../components/Layout/ContentWrapper';
import { UI_HEIGHT } from '../Common/constants';
import Spinner from '../Widgets/spinner';
import { DisabledInputField } from '../Common/inputField';
import DisplayDataGrid from '../../components/Common/DisplayDataGrid';
import PriceFormatter from '../Common/priceFormatter';
import checkPermission from '../Common/permissions';
import { numberWithCommas } from '../Common/numberWithCommas';
import ReportsModal from './ReportsModal';
import { getLocalStorageData } from '../../reducers/headerRedux'
import { ROOT_URL, companyCodeTitle, isGGI, isCT, isSDR } from '../../actions/root_url';

class RowRenderer extends Component {
  render() {
    // here we are just changing the style
    // but we could replace this with anything we liked, cards, images, etc
    // usually though it will just be a matter of wrapping a div, and then calling back through to the grid
    return (<div onDoubleClick={() => { this.props.onDoubleClick(this.props.row); }} ><ReactDataGrid.Row ref="row" {...this.props} /></div>);
  }
}

RowRenderer.PropTypes = {
  onDoubleClick: React.PropTypes.func,
};

class PresidentDashboard extends Component {
    static contextTypes = {
      router: React.PropTypes.object,
    };

    constructor() {
      super();
      this.state = {
        tableHeight: window.innerHeight - UI_HEIGHT.presidentDashboard,


        customers: {
          rows: [],
          sortColumn: null,
          sortDirection: null,
        },

        // Data input for OverallPerformance
        overallPerformance: {},

        // Data input for PurchasePerformance
        salesPerformance: {},

        purchaseOrderRows: [],
        salesOrderRows: [],
        mobileSalesOrderRows: [],
        posOrderRows: [],
        apReportRows: [],
        arReportRows: [],
        consolodatedStatisticsDate: new Date(),
        fromStatisticsDate: new Date(),
        toStatisticsDate: new Date(),
        isReportModalvisible: false,
      };

      this.handleResize = this.handleResize.bind(this);
    }

    componentDidMount() {
      document.title = companyCodeTitle;
      window.addEventListener('resize', this.handleResize);
      const activeCompany = getLocalStorageData('selectedCompany')
      this.props.fetchCustomersStatus();
      // this.props.fetchPurchaseTotals('user', 'daily');
      this.props.fetchSalesTotals('weekly');
      this.props.fetchPresidentDashInfo();
      this.props.fetchConsolidatedStatistics(new Date());
      if (isGGI && activeCompany) {
        this.props.fetchCustomerStatementList('Active', moment.utc().toISOString(), '', activeCompany.value);
        this.props.fetchVendorStatementList('Active', moment().format('YYYY-MM-DD'), activeCompany.value);
      } else {
        this.props.fetchCustomerStatementList('Active', moment.utc().toISOString());
        this.props.fetchVendorStatementList('Active', moment().format('YYYY-MM-DD'));
      }
      this.props.fetchOverallPurchasePerformance('weekly')
        .then(() => {
          this.props.fetchOverallSalesPerformance('weekly');
        });
    }

    componentWillUnmount() {
      window.removeEventListener('resize', this.handleResize);
    }

    componentWillReceiveProps(nextProps) {
      if (nextProps.customersStatuses && nextProps.customersStatuses != this.props.customersStatuses) {
        const customers = { ...this.state.customers, rows: nextProps.customersStatuses };
        this.setState({ customers });
      }

      if (nextProps.OverallPeriod && nextProps.OverallPeriod != this.props.OverallPeriod) {
        if (nextProps.OverallPeriod == 'monthly') {
          this.props.fetchOverallPurchasePerformance('monthly')
            .then(() => {
              this.props.fetchOverallSalesPerformance('monthly');
            });
        } else {
          this.props.fetchOverallPurchasePerformance('weekly')
            .then(() => {
              this.props.fetchOverallSalesPerformance('weekly');
            });
        }
      }

      if (nextProps.SalesPeriod && nextProps.SalesPeriod != this.props.SalesPeriod) {
        if (nextProps.SalesPeriod == 'week') {
          this.props.fetchSalesTotals('weekly');
        } else {
          this.props.fetchSalesTotals('monthly');
        }
      }

      if (nextProps.salesTotals && nextProps.salesTotals != this.props.salesTotals) {
        const months = [0, 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        const salesTotals = new Sales();
        nextProps.salesTotals.forEach((record) => {
          if (this.props.SalesPeriod == 'month') {
            salesTotals.labels.push(months[record.Month]);
          } else {
            salesTotals.labels.push(record.Day);
          }

          salesTotals.datasets[0].data.push(record.TotalCost);
          salesTotals.datasets[1].data.push(record.TotalSales);
          // salesTotals.datasets[2].data.push(record.POS);
        });
        this.setState({ salesPerformance: salesTotals });
      }

      if (nextProps.overallPurchases && nextProps.overallPurchases != this.props.overallPurchases) {
        const overallPerformance = new Performance();
        const months = [0, 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        nextProps.overallPurchases.forEach((record) => {
          if (this.props.OverallPeriod == 'monthly') {
            overallPerformance.labels.push(months[record.Month]);
          } else {
            overallPerformance.labels.push(record.Day);
          }
          if (record.TotalPurchases == null) {
            overallPerformance.datasets[0].data.push(0);
          } else {
            overallPerformance.datasets[0].data.push(record.TotalPurchases);
          }
        });
        this.setState({ overallPerformanceTemp: overallPerformance });
      }

      if (nextProps.overallSales && nextProps.overallSales != this.props.overallSales && nextProps.overallSales.length !== 0) {
        const overallPerformance = { ...this.state.overallPerformanceTemp };
        nextProps.overallSales.forEach((record) => {
          if (record.TotalSales == null) {
            overallPerformance.datasets[1].data.push(0);
          } else {
            overallPerformance.datasets[1].data.push(record.TotalSales);
          }
        });
        this.setState({ overallPerformance });
      }

      // if (nextProps.presidentInfo && nextProps.presidentInfo != this.props.presidentInfo) {
      //     let presidentInfo =
      // }

      if (nextProps.consolodatedStatistics && nextProps.consolodatedStatistics !== this.props.consolodatedStatistics) {
        this.setState({
          purchaseOrderRows: nextProps.consolodatedStatistics.Purchase_Order,
          salesOrderRows: nextProps.consolodatedStatistics.Sales_Order,
          mobileSalesOrderRows: nextProps.consolodatedStatistics.Mobile_Sales_Order,
          posOrderRows: nextProps.consolodatedStatistics.POS_Order,
          totalPurchasePrice: nextProps.consolodatedStatistics.Purchase_Total_Final_Price,
          totalSalesPrice: nextProps.consolodatedStatistics.Sales_Total_Final_Price,
        });
      }

      if (nextProps.customerStatementList && nextProps.customerStatementList !== this.props.customerStatementList) {
        const {
          statement_lines,
          amount00_07,
          amount08_30,
          amount00_30,
          amount31_60,
          amount61_90,
          amount_91,
          current,
          grand_amount,
        } = nextProps.customerStatementList;

        this.setState({
          arReportRows: statement_lines,
          amount00_07: parseFloat(amount00_07 || 0).toFixed(2),
          amount08_30: parseFloat(amount08_30 || 0).toFixed(2),
          amount00_30: parseFloat(amount00_30 || 0).toFixed(2),
          amount31_60: parseFloat(amount31_60 || 0).toFixed(2),
          amount61_90: parseFloat(amount61_90 || 0).toFixed(2),
          amount_91: parseFloat(amount_91 || 0).toFixed(2),
          current: parseFloat(current || 0).toFixed(2),
          grand_amount: parseFloat(grand_amount || 0).toFixed(2),
        });
      }

      if(nextProps.vendorStatementList && nextProps.vendorStatementList !== this.props.vendorStatementList) {
      const {
        statement_lines,
        amount00_30,
        amount31_60,
        amount61_90,
        amount_91,
        current,
        grand_amount,
      } = nextProps.vendorStatementList;

      this.setState({
        apReportRows: statement_lines,
        apAmount00_30: parseFloat(amount00_30).toFixed(2) || 0,
        apAmount31_60: parseFloat(amount31_60).toFixed(2) || 0,
        apAmount61_90: parseFloat(amount61_90).toFixed(2) || 0,
        apAmount_91: parseFloat(amount_91).toFixed(2) || 0,
        apCurrent: parseFloat(current).toFixed(2) || 0,
        apGrand_amount: parseFloat(grand_amount).toFixed(2) || 0,
      });
    }
    }

    handleResize(e) {
      this.setState({ tableHeight: window.innerHeight - UI_HEIGHT.presidentDashboard });
    }

    renderPresidentSalesInfo = () => (
      <div>
        <div className="sales-order-data-grid">
          <DisplayDataGrid
            columns={SalesOrderColumns}
            rows={this.state.salesOrderRows}
            minHeight={76}
            rowHeight={25}
          />
        </div>
        <div className="mobile-sales-order-data-grid">
          <DisplayDataGrid
            columns={MobileSalesOrderColumns}
            rows={this.state.mobileSalesOrderRows}
            minHeight={76}
            rowHeight={25}
          />
        </div>
        <div className="pos-sales-order-data-grid">
          <DisplayDataGrid
            columns={POSOrderColumns}
            rows={this.state.posOrderRows}
            minHeight={76}
            rowHeight={25}
          />
        </div>
      </div>
    )

    renderPresidentPurchasingInfo() {
      if (this.props.presidentInfoIsLoading && !this.props.presidentInfoError) return <Spinner />;
      else if (this.props.presidentInfoError) {
        return (<ContentWrapper>
          <div className="alert alert-danger">{JSON.stringify(this.props.presidentInfoError)}</div>
        </ContentWrapper>);
      }

      return (
        <div>
          {/*
              <Row>
                <Col xs={6}>
                  <Row>
                    <Col sm={6}>
                      <Label bsStyle="primary"><Translate value="total_account_receivable" /></Label>
                    </Col>
                    <Col sm={6}>
                      <span className='pull-right'>{this.props.presidentInfo.TotalAR && this.props.presidentInfo.TotalAR.toFixed(2)}</span>
                    </Col>
                  </Row>
                </Col>
                <Col xs={6}>
                  <Row>
                    <Col sm={6}>
                      <Label bsStyle="primary"><Translate value="total_outstanding_invoice" /></Label>
                    </Col>
                    <Col sm={6}>
                      <span className='pull-right'>{this.props.presidentInfo.OutstandingAR && this.props.presidentInfo.OutstandingAR.toFixed(2)}</span>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row>
                <Col xs={6}>
                  <Row>
                    <Col sm={6}>
                      <Label bsStyle="primary"><Translate value="total_account_payable" /></Label>
                    </Col>
                    <Col sm={6}>
                      <span className='pull-right'>{this.props.presidentInfo.TotalAP && this.props.presidentInfo.TotalAP.toFixed(2)}</span>
                    </Col>
                  </Row>
                </Col>
                <Col xs={6}>
                  <Row>
                    <Col sm={6}>
                      <Label bsStyle="primary"><Translate value="total_passed_due" /></Label>
                    </Col>
                    <Col sm={6}>
                      <span className='pull-right'>{this.props.presidentInfo.OutstandingAP && this.props.presidentInfo.OutstandingAP.toFixed(2)}</span>
                    </Col>
                  </Row>
                </Col>
              </Row>
            */}
          <div className="purchasingDataGrid">
            <DisplayDataGrid
              id="testing-if-id-actually-works"
              className="123123"
              columns={PurchaseOrderColumns}
              rows={this.state.purchaseOrderRows}
              minHeight={76}
              rowHeight={25}
            />
          </div>
        </div>
      );
    }

    renderTable() {
      if (this.props.customerStatementListIsLoading && !this.props.customerStatementListError) {
        return (
          <div id="spinner">
            <Spinner />
          </div>
        );
      } else if (this.props.customerStatementListError) {
        return (
          <div className="alert alert-danger">
            <Translate value="something_unexpected_happened" />
          </div>
        );
      }

      // Parameters of the react-data-grid

      const tableHeight = (window.innerHeight < 930) ? 510 : 510;

      const getRows = () => Data.Selectors.getRows(this.state);

      const getSize = () => getRows().length;

      const rowGetter = (rowIdx) => {
        const rows = getRows();
        return rows[rowIdx];
      };


      // Handle the sortable function

      const handleGridSort = (sortColumn, sortDirection) => {
        const lines = Object.assign({}, this.state.statementLines, { sortColumn, sortDirection });
        this.setState({ statementLines: lines });
      };


      // Custom Formatter component

      const DateFormatter = React.createClass({
        render() {
          if (this.props.value) {
            const dateMap = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
            const date = new Date(this.props.value);
            const index = dateMap.indexOf(date.toString().slice(4, 3));
            const localDate = index + date.toString().slice(8, 6);
            return <span>{date.toString().slice(4, 15)}</span>;
          }
          return <span className="label label-danger">-</span>;
        },
      });

      // Column difinition

      const columns = [
        {
          key: 'CustomerNum',
          name: <Translate value="customer_num" />,
          resizable: true,
          sortable: true,
          width: 120,
        },
        {
          key: 'Name',
          name: <Translate value="customer_name" />,
          resizable: true,
          sortable: true,
          width: 200,
        },
        {
          key: 'Description',
          name: <Translate value="description" />,
          resizable: true,
          sortable: true,
          width: 110,
        },
        // {
        //     key: 'current',
        //     name: <Translate value="current" />,
        //     resizable: true,
        //     sortable: true,
        //     width: 80,
        //     formatter: PriceFormatter,
        // },
        {
          key: 'amount00_30',
          name: <Translate value="00_dashsign_30_days" />,
          resizable: true,
          sortable: true,
          width: 80,
          formatter: PriceFormatter,
        },
        {
          key: 'amount31_60',
          name: <Translate value="31_dashsign_60_days" />,
          resizable: true,
          sortable: true,
          width: 80,
          formatter: PriceFormatter,
        },
        {
          key: 'amount61_90',
          name: <Translate value="61_dashsign_90_days" />,
          resizable: true,
          sortable: true,
          width: 80,
          formatter: PriceFormatter,
        },
        {
          key: 'amount_91',
          name: <Translate value="91_plussign_days" />,
          resizable: true,
          sortable: true,
          width: 80,
          formatter: PriceFormatter,
        },
        {
          key: 'total_amount',
          name: <Translate value="total_amount" />,
          resizable: true,
          sortable: true,
          width: 100,
          formatter: PriceFormatter,
        },

      ];

      if (isCT) {
        const arPeriod = _.findIndex(columns, { key: 'amount00_30' });
        const estColum1 = {
          key: 'amount00_07',
          name: <Translate value="00_dashsign_07_days" />,
          resizable: true,
          sortable: true,
          width: 80,
          formatter: PriceFormatter,
        };
        const estColum2 = {
          key: 'amount08_30',
          name: <Translate value="08_dashsign_30_days" />,
          resizable: true,
          sortable: true,
          width: 80,
          formatter: PriceFormatter,
        };
        columns.splice(arPeriod, 1, estColum1);
        columns.splice(arPeriod+1, 0, estColum2);
      }

      // React Table Purchase Order Full Table
      return (
        <Row>
          {
            !isCT &&
            <Col xs={4}>
              <label className="col-xs-6 text-align-right"><Translate value="00_dashsign_30_days" /></label>
              <Col xs={6}>
                <Field name="amount00_30" component={DisabledInputField} placeholder={!isNaN(this.state.amount00_30) && `$${numberWithCommas(this.state.amount00_30)}`} />
              </Col>
            </Col>
          }
          {
            isCT &&
            <div>
              <Col xs={4}>
                <label className="col-xs-6 text-align-right"><Translate value="00_dashsign_07_days" /></label>
                <Col xs={6}>
                  <Field name="amount00_07" component={DisabledInputField} placeholder={!isNaN(this.state.amount00_07) && `$${numberWithCommas(this.state.amount00_07)}`} />
                </Col>
              </Col>
              <Col xs={4}>
                <label className="col-xs-6 text-align-right"><Translate value="08_dashsign_30_days" /></label>
                <Col xs={6}>
                  <Field name="amount08_30" component={DisabledInputField} placeholder={!isNaN(this.state.amount08_30) && `$${numberWithCommas(this.state.amount08_30)}`} />
                </Col>
              </Col>
            </div>
          }
          <Col xs={4}>
            <label className="col-xs-6 text-align-right"><Translate value="31_dashsign_60_days" /></label>
            <Col xs={6}>
              <Field name="amount31_60" component={DisabledInputField} placeholder={!isNaN(this.state.amount31_60) && `$${numberWithCommas(this.state.amount31_60)}`} />
            </Col>
          </Col>
          <Col xs={4}>
            <label className="col-xs-6 text-align-right"><Translate value="61_dashsign_90_days" /></label>
            <Col xs={6}>
              <Field name="amount61_90" component={DisabledInputField} placeholder={!isNaN(this.state.amount61_90) && `$${numberWithCommas(this.state.amount61_90)}`} />
            </Col>
          </Col>
          <Col xs={4}>
            <label className="col-xs-6 text-align-right"><Translate value="91_plussign_days" /></label>
            <Col xs={6}>
              <Field name="amount_91" component={DisabledInputField} placeholder={!isNaN(this.state.amount_91) && `$${numberWithCommas(this.state.amount_91)}`} />
            </Col>
          </Col>
          <Col xs={4}>
            <label className="col-xs-6 text-align-right"><Translate value="grand_total" /></label>
            <Col xs={6}>
              <Field name="grand_amount" component={DisabledInputField} placeholder={!isNaN(this.state.grand_amount) && `$${numberWithCommas(this.state.grand_amount)}`} />
            </Col>
          </Col>
          <Col xs={12} style={{ paddingTop: '6px' }}>
            <div className="react-table-ar-ap-customer-list-statement" id="PresidentDashboard-dataGrid1">
              {/* <ReactDataGrid
                // rowRenderer={<RowRenderer onDoubleClick={this.statementDetail} />}
                rowKey="Deliver_Customer_id"
                enableCellSelect
                onGridSort={handleGridSort}
                columns={columns}
                rowHeight={25}
                headerRowHeight={45}
                rowGetter={rowGetter}
                rowsCount={getSize()}
                minHeight={420}
              /> */}
              <DisplayDataGrid
                columns={columns}
                rows={this.state.arReportRows}
                rowHeight={25}
                headerRowHeight={45}
                minHeight={420}
              />
            </div>
          </Col>
        </Row>
      );
    }

    renderExportButton() {
      const exportUrl = `${ROOT_URL}v1/dashboard/agingdetails/export/?Bearer=${localStorage.getItem('token')}`;

      return (
        <Row>
          <Col sm={2} smOffset={10} className="export-to-excel">
            <Button
              bsStyle="success"
              className="pull-right"
              href={exportUrl}
            >
              <em className="fa fa-download" />
              <Translate value="excel" />
            </Button>
          </Col>
        </Row>
      );
    }

    renderIncomeExpenseGraph() {
      return (
        <Bar data={this.state.overallPerformance} height={200} width={300} options={{
          maintainAspectRatio: false,
          scales: {
            yAxes: [{
              ticks: {
                beginAtZero: true,
              }
            }],
          },
        }} />
      );
    }

    renderSalesPerformanceGraph() {
      return (
        <Bar data={this.state.salesPerformance} height={200} width={300} options={{
          maintainAspectRatio: false,
          scales: {
            yAxes: [{
              ticks: {
                beginAtZero: true,
              }
            }],
          },
        }} />
      );
    }

    handleStatisticsDateRange(fromDate, toDate) {
      const { fromStatisticsDate, toStatisticsDate } = this.state;
      if (fromDate) {
        if (toStatisticsDate && (Date.parse(fromDate) <= Date.parse(toStatisticsDate))) {
          this.setState({ fromStatisticsDate: fromDate });
          this.props.fetchConsolidatedStatistics(fromDate, toStatisticsDate);
        } else {
          this.setState({ fromStatisticsDate: fromDate, toStatisticsDate: null });
        }
      }
      if (toDate) {
        if (fromStatisticsDate && (Date.parse(toDate) >= Date.parse(fromStatisticsDate))) {
          this.setState({ toStatisticsDate: toDate });
          this.props.fetchConsolidatedStatistics(fromStatisticsDate, toDate);
        } else {
          this.setState({ toStatisticsDate: toDate, fromStatisticsDate: null });
        }
      }
    }

    setReportModalVisibility = (isReportModalvisible = false) => this.setState({ isReportModalvisible });

    render() {
      const header = (
        <h1><Translate value="finance_performance" /></h1>
      );

      const height = (this.state.tableHeight / 2 + 10).toString();
      const tableCollapseFix = { height: 550 };
      const tableCollapseFixFirstRow = { height: 300 };
      const lineData = {
        labels: ['January', 'February', 'March', 'April'],
        datasets: [
          {
            label: 'My First dataset',
            backgroundColor: [
              'rgba(255, 99, 132, 0.2)',
              'rgba(54, 162, 235, 0.2)',
              'rgba(255, 206, 86, 0.2)',
              'rgba(75, 192, 192, 0.2)',
            ],
            borderColor: [
              'rgba(255,99,132,1)',
              'rgba(54, 162, 235, 1)',
              'rgba(255, 206, 86, 1)',
              'rgba(75, 192, 192, 1)',
            ],
            data: [65, 59, 80, 81],
          },
          {
            label: 'My Second dataset',
            backgroundColor: [
              'rgba(255, 99, 132, 0.2)',
              'rgba(54, 162, 235, 0.2)',
              'rgba(255, 206, 86, 0.2)',
              'rgba(75, 192, 192, 0.2)',
            ],
            borderColor: [
              'rgba(255,99,132,1)',
              'rgba(54, 162, 235, 1)',
              'rgba(255, 206, 86, 1)',
              'rgba(75, 192, 192, 1)',
            ],
            data: [28, 48, 40, 19],
          },
        ],
      };

      const data = {
        labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
        datasets: [
          {
            label: 'Cost',
            backgroundColor: 'rgba(255,99,132,0.2)',
            borderColor: 'rgba(255,99,132,1)',
            borderWidth: 1,
            hoverBackgroundColor: 'rgba(255,99,132,0.4)',
            hoverBorderColor: 'rgba(255,99,132,1)',
            data: [65, 59, 80, 81, 56, 55, 40],
          },
          {
            label: 'Sale',
            backgroundColor: 'rgba(151,187,205,0.2)',
            borderColor: 'rgba(151,187,205,1)',
            borderWidth: 1,
            hoverBackgroundColor: 'rgba(151,187,205,0.4)',
            hoverBorderColor: 'rgba(151,187,205,1)',
            data: [12, 34, 65, 72, 28, 31, 30],
          },
        ],
      };

      const stackedOptions = {
        maintainAspectRatio: false,
        scales: {
          xAxes: [{
            stacked: true,
          }],
          yAxes: [{
            stacked: true,
          }],
        },
      };

      const options = {
        scales: {
          xAxes: [{
            stacked: false,
          }],
          yAxes: [{
            stacked: false,
          }],
        },
      };

      const incomeExpensePanelHeader = (<h4><Translate value="purchase_sales" /></h4>);
      const salesPerformancePanelHeader = (<h4><Translate value="invoiced_cost" /></h4>);
      const arStatisticsHeader = (
        <Row>
          <Col xs={12} >
            <h4 className="statistics-header"><Translate value="ar_statistics" /></h4>
          </Col>
        </Row>
      );
      const apStatisticsHeader = (
        <Row>
          <Col xs={12} >
            <h4 className="statistics-header"><Translate value="ap_statistics" /></h4>
          </Col>
        </Row>
      );
      const infoPurchaseSalesPanelHeader = (
        <Row style={{ margin: '0' }}>
          <Col xs={6} style={{paddingRight: '0px'}}>
            <h4>
              <Translate value="order_count_overview" />
            </h4>
          </Col>
          <Col xs={3} style={{paddingLeft: '0px', paddingRight: '2px'}}>
            <DateTimePicker
              id="fromStatisticsDate"
              format="MM-DD-YY"
              time={false}
              onChange={(e) => {
                this.handleStatisticsDateRange(e, null);
              }}
              value={this.state.fromStatisticsDate}
            />
          </Col>
          <Col xs={3} style={{paddingRight: '0px', paddingLeft: '2px'}}>
            <DateTimePicker
              id="toStatisticsDate"
              format="MM-DD-YY"
              time={false}
              onChange={(e) => {
                this.handleStatisticsDateRange(null, e);
              }}
              value={this.state.toStatisticsDate}
            />
          </Col>
        </Row>
      );
      const infoPurchasePanelHeader = (
        <Row style={{ margin: '0' }}>
          <Col xs={3}>
            <h3>
              <Translate value="purchasing" />
            </h3>
          </Col>
          <Col xs={9}>
            <h2 className="totals pull-right"><Translate value="total_receive_price" /> <span className="total-price-label">${!isNaN(this.state.totalPurchasePrice) && numberWithCommas(this.state.totalPurchasePrice)}</span></h2>
          </Col>
        </Row>
      );

      const infoSalesPanelHeader = (
        <Row style={{ margin: '0' }}>
          <Col xs={6}>
            <h3>
              <Translate value="sales" />
            </h3>
          </Col>
          <Col xs={6}>
            <h2 className="totals pull-right"><Translate value="total_sales_price" /> <span className="total-sales-label">${!isNaN(this.state.totalSalesPrice) && numberWithCommas(this.state.totalSalesPrice)}</span></h2>
          </Col>
        </Row>
      );
      return (
        //---------------
        // Begin HTML
        //---------------
        <ContentWrapper>
          <Breadcrumb>
            <Breadcrumb.Item active="true">
              <Translate value="president_dashboard" />
            </Breadcrumb.Item>
          </Breadcrumb>
          <ButtonToolbar id="breadcrumbButtonGroup">
            <Button
              bsStyle="success"
              type="button"
              onClick={() => {
                this.setReportModalVisibility(true)
              }}
              // disabled={this.props.currentSalesOrderDetail} //revert risk high
            >
              <em className="fa fa-download" /><Translate value="reports" />
            </Button>
          </ButtonToolbar>
          <Grid id="president-dashboard" fluid="true">
            {/* Charts */}
            <Row>
              <Col sm={6} className="">
                <Panel header={incomeExpensePanelHeader} className="income-expense-chart" style={tableCollapseFixFirstRow}>
                  <Row>
                    <Col sm={4} smOffset={4}>
                      <Field name="OverallPeriod" component={renderRadiosLongPeriod} />
                    </Col>
                  </Row>
                  <Col>
                    {this.renderIncomeExpenseGraph()}
                  </Col>
                </Panel>
              </Col>
              <Col sm={6} className="">
                <Panel header={salesPerformancePanelHeader} className="income-expense-chart" style={tableCollapseFixFirstRow}>
                  <Row>
                    <Col sm={4} smOffset={4}>
                      <Field name="SalesPeriod" component={renderRadiosShortPeriod} />
                    </Col>
                  </Row>
                  <Col>
                    {this.renderSalesPerformanceGraph()}
                  </Col>
                </Panel>
              </Col>
            </Row> {/* End Charts */}

            {/* Tables */}
            <Row>
              <Col sm={6}>
                <Tabs defaultActiveKey={1} justified className="report-tabs">
                  <Tab eventKey={1} title={arStatisticsHeader} id="ar-tab">
                    { this.renderTable() }
                  </Tab>
                  <Tab eventKey={2} title={apStatisticsHeader} id="ar-tab">
                    <div>
                      <Row>
                        <Col xs={4}>
                          <label className="col-xs-6 text-align-right"><Translate value="00_dashsign_30_days" /></label>
                          <Col xs={6}>
                            <Field name="apAmount00_30" component={DisabledInputField} placeholder={!isNaN(this.state.apAmount00_30) && `$${numberWithCommas(this.state.apAmount00_30)}`} />
                          </Col>
                        </Col>
                        <Col xs={4}>
                          <label className="col-xs-6 text-align-right"><Translate value="31_dashsign_60_days" /></label>
                          <Col xs={6}>
                            <Field name="apAmount31_60" component={DisabledInputField} placeholder={!isNaN(this.state.apAmount31_60) && `$${numberWithCommas(this.state.apAmount31_60)}`} />
                          </Col>
                        </Col>
                        <Col xs={4}>
                          <label className="col-xs-6 text-align-right"><Translate value="61_dashsign_90_days" /></label>
                          <Col xs={6}>
                            <Field name="apAmount61_90" component={DisabledInputField} placeholder={!isNaN(this.state.apAmount61_90) && `$${numberWithCommas(this.state.apAmount61_90)}`} />
                          </Col>
                        </Col>
                        <Col xs={4}>
                          <label className="col-xs-6 text-align-right"><Translate value="91_plussign_days" /></label>
                          <Col xs={6}>
                            <Field name="apAmount_91" component={DisabledInputField} placeholder={!isNaN(this.state.apAmount_91) && `$${numberWithCommas(this.state.apAmount_91)}`} />
                          </Col>
                        </Col>
                        <Col xs={4}>
                          <label className="col-xs-6 text-align-right"><Translate value="grand_total" /></label>
                          <Col xs={6}>
                            <Field name="apGrand_amount" component={DisabledInputField} placeholder={!isNaN(this.state.apGrand_amount) && `$${numberWithCommas(this.state.apGrand_amount)}`} />
                          </Col>
                        </Col>
                        <Col xs={12} style={{ paddingTop: '6px' }}>
                          <DisplayDataGrid
                            columns={APReportColumns}
                            rows={this.state.apReportRows}
                            rowHeight={25}
                            headerRowHeight={45}
                            minHeight={420}
                          />
                        </Col>
                      </Row>
                    </div>
                  </Tab>
                </Tabs>
              </Col>
              <Col sm={6}>
                <Panel header={infoPurchaseSalesPanelHeader} className="president-purchase-info">
                  {infoPurchasePanelHeader}
                  {this.renderPresidentPurchasingInfo()}
                {/* </Panel>
                <Panel header={infoSalesPanelHeader} className="president-sales-info"> */}
                  {infoSalesPanelHeader}
                  {this.renderPresidentSalesInfo()}
                  <div style={{ lineHeight: '.8em' }}>
                  <span style={{fontSize: "9pt", display: 'inline-block'}}>* <Translate value="total_final_price_calc" /></span>
                  <br></br>
                  <span style={{fontSize: "9pt", display: 'inline-block'}}>* <Translate value="total_sales_price_calc" /></span>
                  <br></br>
                  <span style={{fontSize: "9pt", display: 'inline-block'}}>* <Translate value="total_invoiced_calc" /></span>
                  </div>
                </Panel>
              </Col>
            </Row> {/* End Tables */}
            <ReportsModal
              setModalVisibility={this.setReportModalVisibility}
              isVisible={this.state.isReportModalvisible}
              warehouse_id={this.props.selectedWarehouse && this.props.selectedWarehouse.value}
              company_id={this.props.selectedCompany && this.props.selectedCompany.value}
            />
          </Grid>
        </ContentWrapper>
        //---------------
        // End HTML
        //---------------
      );
    }
}

export default PresidentDashboard;

var renderRadiosLongPeriod = (props) => {
  const titleClass = classNames({ 'parsley-error-label': props.meta.touched && props.meta.error }, 'control-label', 'col-sm-3', 'centerStyle');
  return (
    <div className="optionStyle">
      <Row>
        <Col sm={6}>
          <label className="radio-inline"><Input {...props.input} type="radio" value="weekly" checked={props.input.value == 'weekly' || props.input.value == ''} /><Translate value="Weekly" /></label>
        </Col>
        <Col sm={6}>
          <label className="radio-inline"><Input {...props.input} type="radio" value="monthly" checked={props.input.value == 'monthly'} /><Translate value="Monthly" /></label>
        </Col>
      </Row>
    </div>
  );
};

var renderRadiosShortPeriod = (props) => {
  const titleClass = classNames({ 'parsley-error-label': props.meta.touched && props.meta.error }, 'control-label', 'col-sm-3', 'centerStyle');
  return (
    <div className="optionStyle">
      <Row>
        <Col sm={6}>
          <label className="radio-inline"><Input {...props.input} type="radio" value="week" checked={props.input.value == 'week' || props.input.value == ''} /><Translate value="Weekly" /></label>
        </Col>
        <Col sm={6}>
          <label className="radio-inline"><Input {...props.input} type="radio" value="month" checked={props.input.value == 'month'} /><Translate value="Monthly" /></label>
        </Col>
      </Row>
    </div>
  );
};

// INCOMPLETE: HERE LIES CODE FOR SALES PERFORMANCE IMPLEMENTATION

// <div>
//   <Translate value="sales_performance" /><Field name="SalesPeriod" component={ renderRadiosShortPeriod } />
//   <Bar data={data} height={175} options={{ maintainAspectRatio: false }}/>
// </div>

function Sales() {
  this.labels = [],
  this.datasets = [
    // {
    //   label: 'MSO',
    //   backgroundColor: 'rgba(33, 150, 243, 0.4)',
    //   borderColor: 'rgba(33, 150, 243, 1)',
    //   borderWidth: 1,
    //   hoverBackgroundColor: 'rgba(33, 150, 243, 0.4)',
    //   hoverBorderColor: 'rgba(33, 150, 243, 1)',
    //   data: [],
    // },
    {
      label: I18n.t("total_cost"),
      backgroundColor: 'rgba(255,99,132,0.6)',
      borderColor: 'rgba(255,99,133,1)',
      borderWidth: 1,
      hoverBackgroundColor: 'rgba(255,99,133,0.8)',
      hoverBorderColor: 'rgba(255,99,133,1)',
      data: [],
    },
    {
      label: I18n.t("total_invoiced"),
      backgroundColor: 'rgba(20, 92, 169, 0.4)',
      borderColor: 'rgba(20, 92, 169, 1)',
      borderWidth: 1,
      hoverBackgroundColor: 'rgba(20, 92, 169, 0.6)',
      hoverBorderColor: 'rgba(20, 92, 169, 1)',
      data: [],
    },
  ];
}

function Performance() {
  this.labels = [],
  this.datasets = [
    {
      label: I18n.t("total_received"),
      backgroundColor: 'rgba(255,99,132,0.6)',
      borderColor: 'rgba(255,99,133,1)',
      borderWidth: 1,
      hoverBackgroundColor: 'rgba(255,99,133,0.8)',
      hoverBorderColor: 'rgba(255,99,133,1)',
      data: [],
    },
    {
      label: I18n.t("total_invoiced"),
      backgroundColor: 'rgba(20, 92, 169, 0.4)',
      borderColor: 'rgba(20, 92, 169, 1)',
      borderWidth: 1,
      hoverBackgroundColor: 'rgba(20, 92, 169, 0.6)',
      hoverBorderColor: 'rgba(20, 92, 169, 1)',
      data: [],
    },
  ];
}

const NameFormatter = React.createClass({
  render() {
    if (this.props.value) return <Translate value={`${this.props.value}`} />;
    return <span className="label label-danger">-</span>;
  },
});

const PurchaseOrderColumns = [
  {
    key: 'Name',
    name: <Translate value="po" />,
    resizable: false,
    width: 120,
    formatter: NameFormatter,
  },
  {
    key: 'Total',
    name: <Translate value="order" />,
    resizable: true,
  },
  {
    key: 'Placed',
    name: <Translate value="placed" />,
    resizable: true,
  },
  {
    key: 'Received',
    name: <Translate value="received" />,
    resizable: true,
  },
  {
    key: 'Cancelled',
    name: <Translate value="void" />,
    resizable: true,
  },
];

const SalesOrderColumns = [
  {
    key: 'Name',
    name: <Translate value="so" />,
    resizable: false,
    formatter: NameFormatter,
    width: 120,
  },
  {
    key: 'Total',
    name: <Translate value="order" />,
    resizable: true,
  },
  {
    key: 'Open',
    name: <Translate value="open" />,
    resizable: true,
  },
  {
    key: 'Packing',
    name: <Translate value="packing" />,
    resizable: true,
  },
  {
    key: 'Released',
    name: <Translate value="invoiced" />,
    resizable: true,
  },
  ...(!isSDR || (isSDR && checkPermission('view_sales_profit'))) && [{
    key: 'Finalized',
    name: <Translate value="margin" />,
    resizable: true,
  }],
  {
    key: 'Cancelled',
    name: <Translate value="void" />,
    resizable: true,
    width: 90,
  },
];

const MobileSalesOrderColumns = [
  {
    key: 'Name',
    name: 'MSO',
    resizable: false,
    width: 120,
    formatter: NameFormatter,
  },
  {
    key: 'Total',
    name: <Translate value="order" />,
    resizable: true,
  },
  {
    key: 'Open',
    name: <Translate value="open" />,
    resizable: true,
  },
  {
    key: 'Packing',
    name: <Translate value="packing" />,
    resizable: true,
  },
  {
    key: 'Released',
    name: <Translate value="invoiced" />,
    resizable: true,
  },
  ...(!isSDR || (isSDR && checkPermission('view_sales_profit'))) && [{
    key: 'Finalized',
    name: <Translate value="margin" />,
    resizable: true,
  }],
  {
    key: 'Cancelled',
    name: <Translate value="void" />,
    resizable: true,
    width: 90,
  },
];

const POSOrderColumns = [
  {
    key: 'Name',
    name: 'POS',
    resizable: false,
    width: 120,
    formatter: NameFormatter,
  },
  {
    key: 'Total',
    name: <Translate value="order" />,
    resizable: true,
  },
  {
    key: 'Receipt',
    name: <Translate value="receipt" />,
    resizable: true,
  },
  {
    key: 'Hold',
    name: <Translate value="hold" />,
    resizable: true,
  },
  ...(!isSDR || (isSDR && checkPermission('view_sales_profit'))) && [{
    key: 'Margin',
    name: <Translate value="margin" />,
    resizable: true,
  }],
  {
    key: 'Void',
    name: <Translate value="void" />,
    resizable: true,
  },
];

const APReportColumns = [
  {
    key: 'VendorNum',
    name: <Translate value="vendor_num" />,
    resizable: true,
    sortable: true,
    width: 120,
  },
  {
    key: 'Name',
    name: <Translate value="vendor_name" />,
    resizable: true,
    sortable: true,
    width: 200,
  },
  {
    key: 'Description',
    name: <Translate value="description" />,
    resizable: true,
    sortable: true,
    width: 110,
  },
  /*{
      key: 'current',
      name: <Translate value="current" />,
      resizable: true,
      sortable: true,
      width: 80,
      formatter: PriceFormatter,
  }, */
  {
    key: 'amount00_30',
    name: <Translate value="00_dashsign_30_days" />,
    resizable: true,
    sortable: true,
    width: 80,
    formatter: PriceFormatter,
  },
  {
    key: 'amount31_60',
    name: <Translate value="31_dashsign_60_days" />,
    resizable: true,
    sortable: true,
    width: 80,
    formatter: PriceFormatter,
  },
  {
    key: 'amount61_90',
    name: <Translate value="61_dashsign_90_days" />,
    resizable: true,
    sortable: true,
    width: 80,
    formatter: PriceFormatter,
  },
  {
    key: 'amount_91',
    name: <Translate value="91_plussign_days" />,
    resizable: true,
    sortable: true,
    width: 80,
    formatter: PriceFormatter,
  },
  {
    key: 'total_amount',
    name: <Translate value="total_amount" />,
    resizable: true,
    sortable: true,
    width: 100,
    formatter: PriceFormatter,
  },
];



// WEBPACK FOOTER //
// ./master/jsx/components/Purchase/presidentDashboard.jsx